
import { EventBus } from '@/utils/event_bus';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class extends Vue {
  @Prop() menuOpen!: boolean;

  get active() {
    return this.$route.name;
  }

  handleCickMenu(e: any) {
    const menu = e.target.dataset.menu;
    if (menu) {
      if(menu.includes('Home')) {
        if (menu === 'Home') {
          EventBus.$emit('scroll-to-view');
        } else {
          this.$router.push({ name: 'Home', params: { view: 'view' } })
        }
      } else if(this.active !== menu) {
        this.$router.push({ name: menu })
      }
    }
  }
}
